<template>
  <div v-if="!empty" class="editor-view-wrapper" v-html="content">
  </div>
  <div v-else class="empty-page">
    {{emptyText}}
  </div>
</template>

<script>
// 积分礼品详情页面
import { Toast } from 'vant'
import { getGiftInfo } from 'api/integral_gift'

export default {
  name: 'IntegralGift',
  data () {
    return {
      token: '',
      giftId: '',
      content: '',
      empty: false,
      emptyText: '无法查询到该礼品'
    }
  },
  created () {
    this.giftId = this.$route.query.id
    const { token } = this.$store.getters
    try {
      // const testToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiQVBQIiwidGltZXN0YW1wIjoxNTU5MTA5Njg3MDk0LCJwaG9uZSI6IjEzOTgzMDkxMjc1IiwidXNlcklkIjoiMjc3MjkyY2QtOWM1YS00OTE1LWE4ZGQtNTAyNzhiMjBiMzUxIiwiaGVhZGltZ1VybCI6Imh0dHBzOi8vY2VzaGkubW90b3Jqb3VybmV5LmNuLzE1MzI0ODYzMjQ2NzQuanBnIiwibmlja25hbWUiOiLlkInku5bmmLXnp7DljYHkupTlrZflk4jlk4jlk4jlk4jlk4jlk4jlk4jlrowiLCJ1c2VybmFtZSI6IjEzOTgzMDkxMjc1IiwiaWF0IjoxNTU5MTA5Njg3LCJleHAiOjE1NjE3MDE2ODd9.G16Dwjax_mefsTnfCykYFNaq2yS_KG7eSBNllCPu8I8'
      this.token = window._native_ ? window._native_.getToken() : token // 这里可以加上测试的key进行调试
    } catch (error) {
      console.log(error)
      console.warn('Token赋值错误')
    }
    if (!this.token) {
      Toast.fail('Token不存在')
      console.warn('Token不存在')
      return
    }
    if (!this.giftId) {
      this.empty = true
      this.emptyText = '参数错误'
      Toast.fail('参数错误')
      return
    }
    this.$nextTick(() => {
      this.getInfo()
    })
  },
  methods: {
    getInfo () {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getGiftInfo({ id: this.giftId }, this.token).then(res => {
        const data = res.data.data
        if (data.integralGiftId === 0) {
          this.empty = true
        } else {
          this.content = data.content
        }
      }).catch(err => {
        console.log(err)
        Toast.fail('请求出错')
      }).finally(() => {
        Toast.clear()
      })
    }
  }
}
</script>

<style lang='less'>
@import '../../style/editor.less';
.empty-page{
  font-size: 0.5rem;
  text-align: center;
  margin-top: 50px;
}
</style>
